import { useMemo } from 'react'
import styled from 'styled-components'
import { Trade, Currency } from 'vvs-sdk'
import { Button, Text } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import { computeTradePriceBreakdown, warningSeverity } from 'utils/prices'
import { AutoColumn } from 'components/Layout/Column'
import QuestionHelper from 'components/QuestionHelper'
import { AutoRow, RowBetween, RowFixed } from 'components/Layout/Row'
import BigNumber from 'bignumber.js'
import FormattedPriceImpact from '../FormattedPriceImpact'
import { SwapCallbackError } from '../styles'

const LimitOrdersFooterContainer = styled(AutoColumn)`
  margin-top: 24px;
  padding: 16px;
  border-radius: ${({ theme }) => theme.radii.default};
  // border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  background-color: ${({ theme }) => theme.colors.inputBackground};
`

export default function LimitOrdersModalFooter({
  trade,
  onConfirm,
  limitPrice,
  currencies,
  minReturn,
  gelatoFee,
  swapErrorMessage,
}: {
  limitPrice: string
  currencies: {
    input: Currency
    output: Currency
  }
  trade: Trade
  minReturn: string
  gelatoFee: string
  onConfirm: () => void
  swapErrorMessage: string | undefined
}) {
  const { t } = useTranslation()
  const { priceImpactWithoutFee } = useMemo(() => computeTradePriceBreakdown(trade), [trade])
  const severity = warningSeverity(priceImpactWithoutFee)

  return (
    <>
      <LimitOrdersFooterContainer>
        <RowBetween align="center">
          <Text fontSize="14px">{t('Limit Price')}</Text>
          <Text
            fontSize="14px"
            style={{
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              textAlign: 'right',
              paddingLeft: '10px',
            }}
          >
            {`1 ${currencies.input?.symbol} = ${limitPrice} ${currencies.output?.symbol}`}
          </Text>
        </RowBetween>

        <RowBetween>
          <RowFixed>
            <Text fontSize="14px">{t('Minimum received')}</Text>
            {/* <QuestionHelper
              text={t(
                'Your transaction will revert if there is a large, unfavorable price movement before it is confirmed.',
              )}
              ml="4px"
            /> */}
          </RowFixed>
          <RowFixed>
            <Text fontSize="14px">
              {new BigNumber(minReturn)
                .multipliedBy(new BigNumber(10).exponentiatedBy(-currencies.output?.decimals))
                .toString()}
            </Text>
            <Text fontSize="14px" marginLeft="4px">
              {currencies.output?.symbol?.toUpperCase()}
            </Text>
          </RowFixed>
        </RowBetween>
        <RowBetween>
          <RowFixed>
            <Text fontSize="14px">{t('Price Impact')}</Text>
            <QuestionHelper
              text={t(
                'The difference between the market price and estimated price due to the large trade size compared to the liquidity available',
              )}
              ml="4px"
            />
          </RowFixed>
          <FormattedPriceImpact priceImpact={priceImpactWithoutFee} />
        </RowBetween>
        <RowBetween>
          <RowFixed>
            <Text fontSize="14px">{t('Limit Order Fee')}</Text>
            {/* <QuestionHelper
              text={
                <>
                  <Text mb="12px">{t('For each trade a %amount% fee is paid', { amount: '0.30%' })}</Text>
                  <Text>- {t('%amount% to LP token holders', { amount: '0.20%' })}</Text>
                  <Text>- {t('%amount% to the Treasury', { amount: '0.10%' })}</Text>
                </>
              }
              ml="4px"
            /> */}
          </RowFixed>
          <Text fontSize="14px">
            {gelatoFee
              ? `${new BigNumber(gelatoFee)
                  .multipliedBy(new BigNumber(10).exponentiatedBy(-currencies.output?.decimals))
                  .toString()}
 ${currencies.output?.symbol?.toUpperCase()}`
              : '-'}
          </Text>
        </RowBetween>
      </LimitOrdersFooterContainer>

      <AutoRow>
        <Button
          variant={severity > 2 ? 'danger' : 'primary'}
          onClick={onConfirm}
          mt="12px"
          id="confirm-swap-or-send"
          width="100%"
        >
          {severity > 2 ? t('Confirm Limit Order Anyway') : t('Confirm Limit Order')}
        </Button>

        {swapErrorMessage ? <SwapCallbackError error={swapErrorMessage} /> : null}
      </AutoRow>
    </>
  )
}
